import React from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import {ReactComponent as SVGIcon} from './files/AssignmentAdd.svg';

export default (props) => <SvgIcon component={SVGIcon} {...props} />;
